<template>
  <div v-loading="loading" class="mainDiv">
    <div class="head clearfix">
      <el-button
        type="primary"
        size="small"
        @click="goBack"
        class="head-li"
        style="float: left"
        >返回</el-button
      >
      <h3 class="head-li" style="text-align: center">批阅作业</h3>
    </div>
    <el-row type="flex" justify="start" align="middle">
      <el-col :span="10" style="margin-left: 10px">
        <el-button size="small" type="primary" @click="batch(1)"
          >导出附件</el-button
        >
        <el-button size="small" type="primary" @click="batch(2)"
          >导出学生列表</el-button
        >
      </el-col>
    </el-row>
    <el-form ref="query" label-width="60px" style="width: 230px">
      <el-form-item label="状态：" prop="readStatusList">
        <el-select
          v-model="readStatus"
          size="small"
          @change="handlereadStatusChange"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in readStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      border
      style="width: 100%"
      @selection-change="handleSelectionChange"
      size="small"
      :header-cell-style="{ 'background-color': '#e8eff9' }"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="id" v-if="false"></el-table-column>
      <el-table-column width="50" label="序号">
        <template slot-scope="scope">{{
          scope.$index + 1 + (pageObj.page - 1) * pageObj.pageSize
        }}</template>
      </el-table-column>
      <el-table-column prop="uname" label="学生姓名"></el-table-column>
      <el-table-column prop="phone" label="手机号"></el-table-column>
      <el-table-column prop="admission_card" label="准考证号"></el-table-column>
      <el-table-column prop="submit_date" label="提交时间">
        <template #default="scope">{{
          scope.row.submit_date | datetimeFormat
        }}</template>
      </el-table-column>
      <el-table-column
        prop="answer_accessory"
        label="答题附件"
      ></el-table-column>
      <el-table-column prop="submit_number" label="提交次数"></el-table-column>
      <el-table-column
        v-if="false"
        prop="repeat_chance"
        label="查重率"
      ></el-table-column>
      <el-table-column prop="marking_score" label="评分"></el-table-column>
      <el-table-column prop="marking_comment" label="评语"></el-table-column>
      <el-table-column prop="stauts" label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.stauts == '1'">未批阅</span>
          <span v-if="scope.row.stauts == '2'">已批阅</span>
          <span v-if="scope.row.stauts == '3'">已退回</span>
          <span v-if="scope.row.stauts == '0'">未提交</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280">
        <template slot-scope="scope">
          <div v-if="scope.row.stauts == '1'">
            <span class="operation" @click="marking(scope.row)">批阅</span>
            <span class="operation" @click="read(scope.row)">退回</span>
          </div>
          <div v-if="scope.row.stauts == '2' || scope.row.stauts == '3'">
            <span class="operation" @click="Info(scope.row)">查看详情</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageObj.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageObj.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      background
      :total="total"
    >
    </el-pagination>

    <section v-if="showSendback" class="send-back">
      <h3>退回原因</h3>
      <textarea
        class="send-back-textarea"
        v-model="checkComment"
        name="checkComment"
        id="checkComment"
        cols="60"
        rows="15"
      ></textarea>
      <div class="clearfix" style="margin-top: 10px">
        <el-button
          type="primary"
          @click="showSendback = 0"
          style="margin: 0; width: 98px; float: right"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="onSubmit()"
          style="margin: 0 20px; width: 98px; float: right"
          >确认退回</el-button
        >
      </div>
    </section>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/homework/homework'
export default {
  name: 'HomeworkList',
  components: {
    //    RegistrationReviewEdit,
    //    RegistrationReviewNotPass
  },
  data() {
    return {
      loading: false,
      readStatus: '',
      readStatusList: [
        { value: '', label: '请选择' },
        { value: '2', label: '已批阅' },
        { value: '1', label: '待批阅' },
        { value: '0', label: '未提交' },
        { value: '3', label: '已退回' },
      ],
      NoticeTypeList: [
        { value: '1', label: '小组公告' },
        { value: '0', label: '课程公告' },
      ],
      query: {
        professionId: '',
        courseName: '',
        admissionCard: '',
        uName: '',
        datetime: [],
      },
      tableData: [
        {
          orderId: '毕业论文选题通知',
          uname: '毕业论文选题要求',
          phone: '小组公告',
          professionName: '组1',
          courseName: '50/68',
          admissionCard: '张老师',
          zname: '2020-10-10',
          ptime: '2020-10-10',
          submit_date: '2020-10-10',
        },
      ],
      ruleForm: {
        applyNums: '',
      },
      // 分页
      pageObj: {
        page: 1,
        pageSize: 20,
      },
      // 总数
      total: 0,
      // 选中的数组
      selectedList: [],
      isShowDialog: false,
      isShowDialogNotPass: false,
      showSendback: 0,
      readId: '',
      checkComment: '',
    }
  },
  methods: {
    // 监听状态切换
    handlereadStatusChange() {
      this.pageObj.page = 1
      this.getList()
    },

    // 获取数据
    getList() {
      // this.loading = true;
      const { page, pageSize } = this.pageObj
      const homeworkId = this.$route.query.homeworkId
      let reqdata = {
        id: homeworkId,
        page: page,
        pageSize: pageSize,
        status: this.readStatus,
      }
      api.getHomeworkAnswerList(reqdata).then((res) => {
        const result = res
        console.log(result.data.data)
        this.tableData = result.data.data.list
        this.total = result.data.data.total
        // this.loading = false;
      })
    },
    //删除数据
    deleteList(reqdata) {
      api.deleteNotice(reqdata).then((res) => {
        if (res.data.code === 100000) {
          this.$message({ type: 'success', message: `已删除！` })
          this.getList()
        } else {
          this.$message({ type: 'warning', message: `删除失败！` })
        }
      })
    },
    //下载所有
    getAllList(reqdata) {
      let uids = ''
      if (this.selectedList.length > 0) {
        this.selectedList.forEach((item) => {
          uids += item.uid + ','
        })
      }
      console.log('---reqdata' + reqdata)
      window.open(
        this.url +
          '/zkfz/zkolHomework/exportExcelHomeworkAnswer?ids=' +
          reqdata +
          '&status=' +
          this.readStatus +
          '&id=' +
          this.$route.query.homeworkId +
          '&uid=' +
          uids
      )
    },
    //下载所有
    getAllFileList(reqdata) {
      window.open(
        this.url +
          '/zkfz/zkolHomework/exportAccessory?ids=' +
          reqdata +
          '&status=' +
          this.readStatus +
          '&id=' +
          this.$route.query.homeworkId
      )
    },
    //    删除个别
    delected(row) {
      confirmMsg('是否删除该条数据？', async () => {
        // const idsArry=[row.id]
        let reqdata = {
          ids: row.id,
          // ids:JSON.stringify([row.id])
        }
        this.deleteList(reqdata)
      })
    },

    //    批量操作
    batch(type) {
      const alldata = this.$refs.multipleTable.selection
      console.log(alldata)
      let allId = ''
      for (let i of alldata) {
        allId += i.id + ','
      }
      console.log('allId:' + allId)
      let reqdata = {
        ids: allId,
      }
      console.log(allId)
      // if (alldata.length == 0) {
      //   this.$message({ type: "error", message: `请勾选` });
      // } else {
      console.log(type)
      if (type === 2) {
        this.getAllList(allId)
      } else {
        this.getAllFileList(allId)
      }

      // }
    },

    //    编辑
    marking(row) {
      const url = 'HomeworkMarking'
      this.$router.push({ name: url, query: { id: row.id, edit_style: '1' } })
    },
    //退回
    read(row) {
      this.showSendback = 1
      this.readId = row.id
    },
    onSubmit() {
      // const url = "HomeworkMarking";
      // this.$router.push({ name: url, query: { id: row.id } });
      if (this.checkComment.trim() === '') {
        return this.$message.warning('退回原因必填！')
      }
      let reqdata = {
        answerId: this.readId,
        checkComment: this.checkComment,
        submitType: 3,
        createUid: localStorage.getItem('uid') ,
      }
      let filedata = this.file
      console.log(filedata)
      api.saveHomeworkMarking(reqdata, filedata).then((res) => {
        console.log(res.data)
        if (res.data.code === 100000) {
          this.$message({ type: 'success', message: `已退回！` })
          this.getList()
          this.showSendback = 0
        } else {
          this.$message({ type: 'warning', message: `退回失败！` })
        }
      })
    },
    //查看
    Info(row) {
      const url = 'HomeworkReaded'
      this.$router.push({ name: url, query: { id: row.id } })
    },
    //查看人员
    members(row) {
      const url = 'NoticeMembers'
      this.$router.push({
        name: url,
        query: { update_date: row.updateDate, notice_id: row.id },
      })
    },
    // 下载文件
    download(row) {
      let reqdata = {
        id: row.id,
      }
      api2.getFile(reqdata).then(({ data }) => {
        api2.getFileName(reqdata).then((data2) => {
          let files = new File([data], data2.data, { type: data.type })
          // const files = new window.File(
          //     [data],
          //     this.files[0].name,
          //     { type: this.files[0].type }
          // );
          console.log(files)
          let blob = new Blob([data], {
            type: `application/${data.type};charset=utf-8`,
          })
          // 获取heads中的filename文件名
          let downloadElement = document.createElement('a')
          // 创建下载的链接
          let href = window.URL.createObjectURL(blob)
          downloadElement.href = href
          // 下载后文件名
          downloadElement.download = files.name
          document.body.appendChild(downloadElement)
          // 点击下载
          downloadElement.click()
          // 下载完成移除元素
          document.body.removeChild(downloadElement)
          // 释放掉blob对象
          window.URL.revokeObjectURL(href)
        })
      })
    },
    // 处理选中事件
    handleSelectionChange(arr) {
      this.selectedList = arr
    },

    // 改变页面接收数据大小
    handleSizeChange(val) {
      this.pageObj.pageSize = val
      this.getList()
    },

    // 改变当前页面
    handleCurrentChange(val) {
      this.pageObj.page = val
      this.getList()
    },

    // 查询
    handleQuery() {
      this.pageObj.page = 1
      this.getList()
    },

    // 重置查询
    resetQuery(formName) {
      this.$refs[formName].resetFields()
      this.handleQuery()
    },

    goBack() {
      window.history.go(-1)
    },
  },
  created() {
    this.getList()
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
.head {
  margin-bottom: 10px;
}
.clearfix:after {
  content: '';
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
.send-back {
  position: fixed;
  width: 50%;
  left: 50%;
  transform: translateX(-50%);
  bottom: 30%;
  border: 1px solid black;
  background-color: white;
  padding: 10px;
}
.send-back-textarea {
  width: 100%;
  padding: 10px;
}
</style>
